/**
 * nr-links-slider — barra di progresso per lo slider CSS scroll-snap dei
 * link/collezioni nel NR Page header (mobile + tablet).
 * Nessuna libreria: legge lo scroll orizzontale della lista e aggiorna la
 * larghezza del fill in percentuale. Su desktop la lista non scrolla
 * (larghezza contenuto = larghezza container) quindi il fill resta inerte.
 */
class NrLinksSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector(".nr-page-header__links");
    this.fill = this.querySelector(".nr-page-header__links-progress-fill");
    if (!this.track) return;

    // Alcuni browser ripristinano lo scroll orizzontale dell'elemento tra un
    // reload/una navigazione e l'altra (scroll anchoring): forziamo la
    // posizione a 0 all'avvio, altrimenti il primo link puo' apparire
    // tagliato a sinistra invece che interamente visibile.
    this.track.scrollLeft = 0;

    this.onScroll = this.onScroll.bind(this);
    this.track.addEventListener("scroll", this.onScroll, { passive: true });
    window.addEventListener("resize", this.onScroll);
    this.onScroll();
  }

  disconnectedCallback() {
    if (!this.track) return;
    this.track.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onScroll);
  }

  onScroll() {
    if (!this.fill) return;
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    const ratio = maxScroll > 0 ? this.track.scrollLeft / maxScroll : 0;
    this.fill.style.width = `${Math.min(100, Math.max(0, ratio * 100))}%`;
  }
}

if (!customElements.get("nr-links-slider")) {
  customElements.define("nr-links-slider", NrLinksSlider);
}
